import React, { useState } from 'react';
import homeStyles from '@app/shop/index.module.less';
import styles from './index.module.less';
import cn from 'classnames';
import { IBanner, IOldFeatureBanner, IPopupsCode } from 'mod/feature/interface';
import { getBannerTrackData, getModuleCode, getModuleElementId, getWrapStyle } from 'base/utils/features';
import { get375RemValue } from 'base/utils/dom-size';
import titleStyles from 'app/styles/modules/title.module.less';
import ModuleTitle, { ModuleTitleProps } from '@base/lib/ModuleTitle';
import BannerImage from '@base/features/BannerImage';
import PopupDrawerModal from 'base/components/common/PopupDrawerModal';
import Tracker from '@base/lib/Tracker';

export type ITiledBannerProps = {
    data: IOldFeatureBanner;
    subWrapClassName?: string;
    titleProps?: ModuleTitleProps;
};

const CONTAINER_WIDTH = process.env.NEXT_PUBLIC_TERMINAL === 'm' ? 375 : 1480; //容器最大宽度

const defaultHeightMap = {
    1: 300,
    2: 410,
    3: 360,
}

function getBannerWidth(column: IOldFeatureBanner['config']['column'], spaceBetweenColumns: number): number {
    return Math.round((CONTAINER_WIDTH + spaceBetweenColumns) / column) - spaceBetweenColumns;
}

const TiledBanner: React.FC<ITiledBannerProps> = (props) => {
    const { data, subWrapClassName, titleProps } = props

    const [popupVisible, setPopupVisible] = useState<boolean>(false)
    const [popupProps, setPopupProps] = useState<{
        popUpsCode?: IPopupsCode;
    }>()

    if (data.lists.length === 0) {
        return null;
    }

    const {
        lists,
        config: {
            column = 1,
            width,
            height,
            spaceBetweenColumns = 20,
            hasSideSpace = 0
        }
    } = data;

    const moduleId = getModuleCode(data);
    const moduleElementId = getModuleElementId(data);
    const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

    const bannerWidth = width ? (isPhone ? (width / 2) : width) : getBannerWidth(column, spaceBetweenColumns);
    const bannerHeight = height ? (isPhone ? (height / 2) : height) : defaultHeightMap[column];
    const fullColumnSpace = isPhone ? get375RemValue(spaceBetweenColumns / 2) : `${spaceBetweenColumns}px`
    const halfColumnSpace = isPhone ? get375RemValue(spaceBetweenColumns / 4) : `${spaceBetweenColumns / 2}px`

    const onPopupClickHandle = (banner: IBanner) => {
        setPopupProps({
            popUpsCode: banner.popUps
        })
        setPopupVisible(true)
    }

    return (
        <>
            <div id={moduleElementId} data-t-mod={moduleId} style={getWrapStyle(data)}>
                <div className={cn(subWrapClassName)}>
                    <ModuleTitle
                        className={cn(titleStyles.title, homeStyles.title)}
                        text={data.title}
                        link={data.readMoreLink}
                        linkText={data.readMoreTitle}
                        {...titleProps}
                    />

                    <div
                        className={cn(
                            styles.list,
                            { 'site-space': hasSideSpace && isPhone }
                        )}
                        style={{
                            marginLeft: `-${halfColumnSpace}`,
                            marginRight: `-${halfColumnSpace}`,
                            rowGap: fullColumnSpace
                        }}
                    >
                        {lists.map((item, i) => (
                            <Tracker
                                key={i}
                                data={getBannerTrackData(item, moduleId, i)}
                            >
                                <div
                                    className={styles.item}
                                    style={{
                                        flex: `0 0 ${100 / column}%`,
                                        paddingLeft: halfColumnSpace,
                                        paddingRight: halfColumnSpace,
                                    }}
                                >
                                    <BannerImage
                                        onPopupClick={onPopupClickHandle}
                                        banner={item}
                                        width={bannerWidth}
                                        height={bannerHeight}
                                        moduleId={moduleId}
                                        index={i}
                                    />
                                </div>
                            </Tracker>
                        ))}
                    </div>
                </div>
            </div>
            {/* 弹窗 */}
            <PopupDrawerModal
                visible={popupVisible}
                setVisible={setPopupVisible}
                {...popupProps}
            />
        </>
    );
};

export default React.memo(TiledBanner);
